<template>
  <div class="visit-data">
    <!-- 顶部筛选区 -->
    <div class="filter-bar f--c fw-w">
      <el-select
        v-model="searchParams.collectionId"
        size="medium"
        filterable
        remote
        reserve-keyword
        clearable
        placeholder="搜索集合"
        :remote-method="remoteMethod"
        @focus="getLaunchCollectionDropdown()"
        @change="handleSearch"
        style="width: 200px; margin-right: 10px; margin-bottom: 10px">
        <el-option
          v-for="item in collectionList"
          :key="item.id"
          :label="item.collectionName"
          :value="item.id">
        </el-option>
      </el-select>
      
      <el-select
        v-model="searchParams.followStatus"
        placeholder="跟进状态"
        clearable
        size="medium"
        style="width: 150px; margin-right: 10px; margin-bottom: 10px"
        @change="handleSearch"
        @clear="handleSearch"
      >
        <el-option label="全部状态" value="" />
        <el-option label="未联系" :value="0" />
        <el-option label="已联系" :value="1" />
      </el-select>
      <el-date-picker
        v-model="searchParams.dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="medium"
        value-format="yyyy-MM-dd"
        style="width: 340px; margin-right: 10px; margin-bottom: 10px"
        @change="handleSearch"
      />
      <el-input
        v-model="searchParams.email"
        placeholder="请输入邮箱"
        clearable
        size="medium"
        style="width: 200px; margin-right: 10px; margin-bottom: 10px"
        @blur="handleSearch"
        @clear="handleSearch"
      />
      <el-button type="primary" size="medium" style="margin-bottom: 10px" @click="handleSearch">查询</el-button>
      <el-button type="primary" size="medium" style="margin-bottom: 10px" @click="exportData">导出数据</el-button>
    </div>

    <!-- 列表 -->
    <el-table
      ref="visitTable"
      v-loading="loading"
      :data="tableData"
      style="width: 100%;"
      height="calc(100vh - 290px)"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="邮箱" min-width="200">
        <template slot-scope="{ row }">
          <div class="f--c">
            <span class="ellipsis" :title="row.email">{{ row.email }}</span>
            <i
              class="el-icon-document-copy pointer"
              style="margin-left: 8px; color: #99c41c; font-size: 16px"
              @click="copyEmail(row.email)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="提交原因" min-width="200" show-overflow-tooltip />
      <el-table-column prop="collectionName" label="关联集合" min-width="150" />
      <el-table-column label="跟进状态" width="150" align="center">
        <template slot-scope="{ row }">
          <el-select
            v-model="row.followStatus"
            size="small"
            @change="handleFollowStatusChange(row)"
          >
            <el-option label="未联系" :value="0" />
            <el-option label="已联系" :value="1" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="200">
        <template slot-scope="{ row }">
          <div class="f--c">
            <span class="ellipsis" :title="row.remark">
              {{ row.remark || '暂无备注' }}
            </span>
            <i
              class="el-icon-edit pointer"
              style="margin-left: 8px; color: #99c41c; font-size: 16px"
              @click="handleEditRemark(row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="提交时间" width="160">
        <template slot-scope="{ row }">
          {{ formatTimeStamp(row.createTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="footer">
      <el-pagination
        background
        :current-page="pagination.pageNumber"
        :page-sizes="[20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 编辑备注对话框 -->
    <el-dialog
      title="编辑备注"
      :visible.sync="remarkDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="remarkFormData.remark"
        type="textarea"
        :rows="4"
        placeholder="请输入备注"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer">
        <el-button size="medium" @click="remarkDialogVisible = false">取消</el-button>
        <el-button type="primary" size="medium" @click="handleRemarkSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'

export default {
  name: 'VisitData',
  data() {
    return {
      loading: false,
      searchParams: {
        collectionName: '',
        followStatus: '',
        dateRange: [],
        email: ''
      },
      collectionList: [],
      tableData: [],
      selectedRows: [],
      pagination: {
        pageNumber: 1,
        pageSize: 20,
        total: 0
      },
      remarkDialogVisible: false,
      remarkFormData: {
        id: null,
        remark: ''
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    formatTimeStamp,
    // 获取集合下拉列表
    getLaunchCollectionDropdown(name) {
      API.getLaunchCollectionDropdown({
        collectionName: name || ''
      }).then(res => {
        this.collectionList = res.data || []
      })
    },
    remoteMethod(query) {
      this.getLaunchCollectionDropdown(query)
    },

    // 获取列表
    getList() {
      this.loading = true
      const params = {
        collectionId: this.searchParams.collectionId,
        followStatus: this.searchParams.followStatus,
        email: this.searchParams.email,
        startTime: this.searchParams.dateRange && this.searchParams.dateRange.length > 0 ? new Date(this.searchParams.dateRange[0] + ' 00:00:00').getTime() : '',
        endTime: this.searchParams.dateRange && this.searchParams.dateRange.length > 0 ? new Date(this.searchParams.dateRange[1] + ' 23:59:59').getTime() : '',
        pageNumber: this.pagination.pageNumber,
        pageSize: this.pagination.pageSize
      }

      API.getLaunchVisitList(params).then(res => {
        this.tableData = res.data.list || []
        this.pagination.total = res.data.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })

      // 模拟数据
      // setTimeout(() => {
      //   this.tableData = [
      //     {
      //       id: 1,
      //       email: 'user1@example.com',
      //       reason: '对新产品感兴趣,希望了解更多详情',
      //       collectionName: '集合1',
      //       followStatus: 0,
      //       remark: '客户表示下周会再次联系',
      //       submitTime: '2024-01-10 10:30:00'
      //     },
      //     {
      //       id: 2,
      //       email: 'user2@example.com',
      //       reason: '想要获取产品目录',
      //       collectionName: '集合2',
      //       followStatus: 1,
      //       remark: '',
      //       submitTime: '2024-01-11 14:20:00'
      //     },
      //     {
      //       id: 3,
      //       email: 'user3@example.com',
      //       reason: '需要产品报价单',
      //       collectionName: '集合1',
      //       followStatus: 0,
      //       remark: '已发送邮件,等待回复',
      //       submitTime: '2024-01-12 09:15:00'
      //     }
      //   ]
      //   this.pagination.total = 3
      //   this.loading = false
      // }, 500)
    },

    // 查询
    handleSearch() {
      this.pagination.pageNumber = 1
      this.getList()
    },

    // 多选
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },

    // 复制邮箱
    copyEmail(email) {
      const input = document.createElement('input')
      input.value = email
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('邮箱已复制')
    },

    // 跟进状态变更
    handleFollowStatusChange(row) {
      if (row.followStatus === 1) {
        this.$confirm('确认将状态改为已联系？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.editLaunchVisitFollowStatus({ id: row.id, followStatus: row.followStatus }).then(() => {
            this.$message.success('状态更新成功')
          }).catch(() => {
            row.followStatus = row.followStatus === 1 ? 0 : 1
          })
        }).catch(() => {
          row.followStatus = row.followStatus === 1 ? 0 : 1
        })
      } else {
        this.$confirm('已联系状态不可更改').then(() => {
          row.followStatus = row.followStatus === 1 ? 0 : 1
        }).catch(() => {
          row.followStatus = row.followStatus === 1 ? 0 : 1
        })
      }


      
    },

    // 编辑备注
    handleEditRemark(row) {
      this.remarkFormData = {
        id: row.id,
        remark: row.remark || ''
      }
      this.remarkDialogVisible = true
    },

    // 备注提交
    handleRemarkSubmit() {
      API.editLaunchVisitRemark(this.remarkFormData).then(() => {
        this.$message.success('备注更新成功')
        this.remarkDialogVisible = false
        this.getList()
      })
    },

    // 分页
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNumber = 1
      this.getList()
    },
    handlePageChange(page) {
      this.pagination.pageNumber = page
      this.getList()
    },

    // 导出数据
    exportData() {
      let form = {
        collectionId: this.searchParams.collectionId,
        followStatus: this.searchParams.followStatus,
        email: this.searchParams.email,
        startTime: this.searchParams.dateRange && this.searchParams.dateRange.length > 0 ? new Date(this.searchParams.dateRange[0] + ' 00:00:00').getTime() : '',
        endTime: this.searchParams.dateRange && this.searchParams.dateRange.length > 0 ? new Date(this.searchParams.dateRange[1] + ' 23:59:59').getTime() : '',
        pageNumber: this.pagination.pageNumber,
        pageSize: this.pagination.pageSize
      }
      let exportForm = {
        fileType: 2,
        taskType: 30,
        condition: JSON.stringify(form)
      }
      this.importExportFile(exportForm)
    },
    //数据导出
    importExportFile(exportForm) {
      API.importExportFile(exportForm).then(() => {
        this.$message.success('数据导出成功,请前往导入导出中心查看进度')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.visit-data {
  .filter-bar {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
  }

  .footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
